module.exports = __webpack_public_path__ + "static/media/Endogyn uses telemedicine software at OB GYN clinic.5ec65f7d.webp";